import { StandaloneAddOn } from '@/hooks/useAddOns';
import { ReviewStartingKit, UpcomingKit } from '@/hooks/useOrderReview';
import { PaymentOptionKit } from '@/hooks/usePaymentOptions';

import { formatMoney } from '@/utils/helpers';
import interpolate from '@/utils/translations/interpolate';
import { TypeSubFlowV3Translations } from '@/utils/translations/TypeSubFlowV3Translations';

export const isPayPerKitOption = (size: number) => {
  return size === 1;
};

export const isBigPufOption = (size: number) => {
  return size >= 4;
};

export const getBundleTitle = (
  isBookBundleOption: boolean,
  size: number,
  t: TypeSubFlowV3Translations,
) => {
  if (size < 2) return t.paymentOptionsPerKit;

  if (isBookBundleOption) return t.paymentOptionsPrepayWithBooksHeading;

  return interpolate(t.paymentOptionsPrepayBig, {
    size,
  });
};

// determines the supporting copy to use in bulleted list within the subflow payment option radio selections
export const getSavingsLabel = ({
  isBfcm2024,
  subSquadEnableBigPuf,
  subSquadEnableDiscountDollarSavings,
  size,
  t,
  savings,
  locale,
}: {
  isBfcm2024?: string | boolean;
  subSquadEnableBigPuf?: string | boolean;
  subSquadEnableDiscountDollarSavings?: boolean;
  size: number;
  t: TypeSubFlowV3Translations;
  savings: number;
  locale: string;
}) => {
  const isPayPerKit = isPayPerKitOption(size);
  const isBigPuf = isBigPufOption(size);

  if (isPayPerKit) {
    return t.ppkText;
  }

  if (isBfcm2024 && !isPayPerKit) {
    return t.bfcm2024PaymentOptionsSavingsLabel;
  }

  let discount = subSquadEnableBigPuf && isBigPuf ? '10%' : '5%';

  if (subSquadEnableDiscountDollarSavings) {
    discount = formatMoney(savings / 100, locale, true);
  }

  return interpolate(t.paymentOptionSavingsLabel, {
    discount,
  });
};

export const hasMultiplePrices = (
  kits: Array<
    PaymentOptionKit | UpcomingKit | ReviewStartingKit | StandaloneAddOn
  >,
) => {
  if (kits.length === 0) return false;

  const currentPrice = kits[0].price;

  return kits.slice(1).some((kit) => {
    if (kit.price !== currentPrice) {
      return true;
    }

    return false;
  });
};
